export default __webpack_public_path__ + "static/media/football-152827_640.8f2fc62b.png";